import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrButton, {
  SR_BUTTON_HEIGHT_SHORT,
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';

import './BulkActionBar.less';

const BulkActionBar = ({ selectedCount, onIgnore, onClear }) => (
  <div styleName="BulkActionBar">
    <div styleName="counter">
      <SrText font="greycliff" weight="700" size="14">
        {selectedCount} selected
      </SrText>
    </div>
    <SrButton
      heightType={SR_BUTTON_HEIGHT_SHORT}
      theme={SR_BUTTON_THEME_ADOBE_YELLOW}
      onClick={onIgnore}
      minWidth="auto"
    >
      Ignore selected
    </SrButton>
    <button type="button" styleName="clearButton" onClick={onClear} aria-label="Clear selection">
      ×
    </button>
  </div>
);

BulkActionBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onIgnore: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

BulkActionBar.displayName = 'BulkActionBar';

export default BulkActionBar;
